module.exports = function (app) {
    "use strict";

    app.controller('pages.employee.find.addCoverage', ["$state", "$scope", "services", "modal", "employee", "$filter","coremetrics",
        function ($state, $scope, services, modal, employee, $filter,coremetrics) {

        if (!employee.editInProgress.isActive()) { $state.go('employee.find'); }

        var ifMedicalProductOpted = false;

        var setBreadCrumbs = function() {
            var prettyName = $filter('capitalize')(employee.data.subscriber.fullName.first) + ' ' +
                $filter('capitalize')(employee.data.subscriber.fullName.last);
            $scope.sidebar.breadCrumb = {
                primary: {
                    title: prettyName,
                    state: "employee.find.addCoverage"
                }
            };
        };

        var initialize = function() {
            $scope.employee = employee.editInProgress.isActive() ? employee.editInProgress : {};
            $scope.addCoverageEffectiveDate = new Date();
            setBreadCrumbs();
        };
        initialize();

        $scope.save = function() {
        //    console.log($state.current.name);
            if($state.current.name == "employee.find.addCoverage"){
                coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:ADD COVERAGE','EMPLOYERS:ENROLLMENT');
            }
            $scope.$broadcast('updatePlans');
        };

        $scope.goBackToEditPage = function() {
            $state.go('employee.find.review', {umi: employee.data.umi, edit: true});
        };

        $scope.$on('plansUpdated', function() {
            //code changes for RF1254817 ND CR
            if(ifMedicalProductOpted){
                $scope.$broadcast('assignTobacco');
            }
            else {
                $scope.$broadcast('updateMajorMedical');
            }

        });

        $scope.$on('tobaccoAssigned', function() {
			$scope.$broadcast('updateMajorMedical');
        });

        $scope.$on('majorMedicalUpdated', function(e, isSuccessful) {
			if (isSuccessful) {
				$scope.goBackToEditPage();
			}
        });

        $scope.reportCodeGroups = [];
        var reportCodeHash = {};
        $scope.$on('planChanged', function(event, product, plan) {
            if (plan) {
                if (reportCodeHash[product]) {
                    var index = $scope.reportCodeGroups.indexOf(reportCodeHash[product]);
                    if (index != -1) {
                        $scope.reportCodeGroups.splice(index,1);
                    }
                }
                $scope.reportCodeGroups.push(plan.groupNumber);
                reportCodeHash[product] = plan.groupNumber;
                $scope.hasReportCodes = $scope.reportCodeGroups.length > 0;
            }
            else {
                var index = $scope.reportCodeGroups.indexOf(reportCodeHash[product]);
                if (index != -1) {
                    $scope.reportCodeGroups.splice(index,1);
                }
                $scope.hasReportCodes = $scope.reportCodeGroups.length > 0;
            }
        });

        //code changes for RF1254817 ND CR
        $scope.$on('medicalPlanUnchecked', function(event, opted) {
            ifMedicalProductOpted =  opted;
        });

        $scope.$on('medicalPlanUpdated', function(event, additionalGroupInformation, plan, optInObj, groupNumber, productEffectiveDate) {
            console.debug('heard medicalPlanUpdated');
             ifMedicalProductOpted =  true;
            $scope.additionalGroupInformation = additionalGroupInformation;
            $scope.groupNumber = groupNumber;
			$scope.productEffectiveDate = productEffectiveDate;
        });
    }]);
};
